import React from "react";
import { ExpandedDescriptionTextSection } from "~/ProductDetails/ProductDetailPageResult";
import Section from "./Section";
interface Props {
  sections: ExpandedDescriptionTextSection[];
}
const ContentTextImageTriple = ({
  sections
}: Props) => <>
    {sections && sections.length === 3 && <div className="detail-section textimage-highlight-template" data-testid="content-image-text-triple">
        <div className="flex-container justify-center">
          <div className="highlight-module highlight-3">
            {sections.map(section => <div className="highlight-item items-center" key={section.headline}>
                <Section section={section} />
              </div>)}
          </div>
        </div>
      </div>}
  </>;
export default ContentTextImageTriple;